import { render, staticRenderFns } from "./ErroNull.vue?vue&type=template&id=a2464264&"
import script from "./ErroNull.vue?vue&type=script&lang=js&"
export * from "./ErroNull.vue?vue&type=script&lang=js&"
import style0 from "./ErroNull.vue?vue&type=style&index=0&id=a2464264&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports